/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * Monitoring icon.
 */
export const ICON_CAPABILITY_MONITORING = (
  <svg fill="none" height="48" viewBox="0 0 48 48" width="48" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M14 10C11.7909 10 10 11.7909 10 14V32C10 35.3137 12.6863 38 16 38H34C36.2091 38 38 36.2091 38 34V16C38 12.6863 35.3137 10 32 10H14ZM14 18C14 16.8954 14.8954 16 16 16C17.1046 16 18 16.8954 18 18V24C18 25.1046 17.1046 26 16 26C14.8954 26 14 25.1046 14 24V18ZM18 30C18 31.1046 17.1046 32 16 32C14.8954 32 14 31.1046 14 30C14 28.8954 14.8954 28 16 28C17.1046 28 18 28.8954 18 30ZM24 16C22.8954 16 22 16.8954 22 18C22 19.1046 22.8954 20 24 20H32C33.1046 20 34 19.1046 34 18C34 16.8954 33.1046 16 32 16H24ZM22 24C22 22.8954 22.8954 22 24 22H32C33.1046 22 34 22.8954 34 24C34 25.1046 33.1046 26 32 26H24C22.8954 26 22 25.1046 22 24ZM24 28C22.8954 28 22 28.8954 22 30C22 31.1046 22.8954 32 24 32H32C33.1046 32 34 31.1046 34 30C34 28.8954 33.1046 28 32 28H24Z"
      fill="#1D9BE2"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M32.4725 7.02734C37.167 7.02734 40.9725 10.8329 40.9725 15.5274L40.9725 31.4022C40.9725 32.2306 41.6441 32.9022 42.4725 32.9022C43.301 32.9022 43.9725 32.2306 43.9725 31.4022L43.9725 15.5274C43.9725 9.17608 38.8238 4.02734 32.4725 4.02734L12.9013 4.02734C12.0729 4.02734 11.4013 4.69891 11.4013 5.52734C11.4013 6.35577 12.0729 7.02734 12.9013 7.02734L32.4725 7.02734Z"
      fill="#1D9BE2"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M15.5085 40.9917C10.814 40.9917 7.00845 37.1861 7.00845 32.4917L7.00846 16.6169C7.00846 15.7884 6.33688 15.1169 5.50846 15.1169C4.68003 15.1169 4.00846 15.7884 4.00846 16.6169L4.00845 32.4917C4.00845 38.843 9.15718 43.9917 15.5085 43.9917L35.0797 43.9917C35.9081 43.9917 36.5797 43.3201 36.5797 42.4917C36.5797 41.6633 35.9081 40.9917 35.0797 40.9917L15.5085 40.9917Z"
      fill="#1D9BE2"
      fillRule="evenodd"
    />
  </svg>
);
